import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CommonApiService } from "src/app/services/common-api.service";
import { FetchUsersActions } from "./fetch-user.index";
import { catchError, map, of, switchMap } from "rxjs";
import { API } from "src/app/common/models/api.enum";
import { FetchUsersResponse } from "src/app/common/models/user-management.model";
import { CommonSignalStore } from "src/app/common/signal-stores/common-store/common.store";
import { AuthorizationService } from "src/app/services/authorization.service";

@Injectable()
export class FetchUsersEffects {
    actions$ = inject(Actions);
    commonApiService = inject(CommonApiService);
    commonStore = inject(CommonSignalStore);
    authorizationService = inject(AuthorizationService);

    fetchUsers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(FetchUsersActions.fetchUsers),
            switchMap((quaryParam ) => {
                const loginData = this.commonStore.loginData()?.data;
                // "root"/"Botjet" org name as a super-admin proxy, OR'd
                // (not replaced) with the real is_superuser flag — see the
                // RBAC implementation checklist.
                const canFilterByOrganization =
                    loginData?.organization?.toLowerCase() === 'botjet' ||
                    loginData?.organization?.toLowerCase() === 'root' ||
                    this.authorizationService.isSuperAdmin();
                const payload: Record<string, any> = {
                    page: quaryParam.page,
                    limit: quaryParam.limit,
                };
                if (canFilterByOrganization) {
                    payload['organization'] = quaryParam.organization;
                }
                const userId = loginData?.userId;
                if (!userId) {
                    return of(FetchUsersActions.fetchUsersError({ error: 'User Id is required' }));
                }

                const fullURL = API.CC_GET_USERS.replace('{{ userId }}', userId);

                return this.commonApiService.get<FetchUsersResponse>(fullURL, payload).pipe(
                    map(response => FetchUsersActions.fetchUsersSuccess({ response })),
                    catchError((error) => of(FetchUsersActions.fetchUsersError({ error })))
                )
            })
        )
    })
}
